import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { componentDesignsDeletedWithInsertions } from '@paragon/layout-models';

export type SaveStatus = 'saved' | 'saving' | 'error';
export interface SaveState {
  [componentDesignGuid: string]: SaveStatus;
}

const initialState: SaveState = {};

const saveSlice = createSlice({
  name: 'save',
  initialState,
  reducers: {
    saveComponentDesignRequest: (state, action: PayloadAction<{ componentDesignGuid: string }>) => {
      state[action.payload.componentDesignGuid] = 'saving';
    },
    saveComponentDesignSuccess: (state, action: PayloadAction<{ componentDesignGuid: string }>) => {
      state[action.payload.componentDesignGuid] = 'saved';
    },
    saveComponentDesignFailure: (state, action: PayloadAction<{ componentDesignGuid: string }>) => {
      state[action.payload.componentDesignGuid] = 'error';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(componentDesignsDeletedWithInsertions, (state, action) => {
      for (const guid of action.payload.guids) {
        delete state[guid];
      }
    });
  },
});

export const { saveComponentDesignRequest, saveComponentDesignSuccess, saveComponentDesignFailure } = saveSlice.actions;
export const save = saveSlice.reducer;
